export const ImageRotation = {
  rotation: 0,
  width: '100%',
  height: '100%'
};


// WEBPACK FOOTER //
// ./src/customModules/Common/DefaultStyle.js